import { Component, EventEmitter, Output, computed } from '@angular/core';
import { IFilterItem } from '../../interfaces';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { NHATestDirective } from '../../../../directives/test/test.directive';

import { FilterBaseComponent } from '../../classes';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
	selector: 'nha-selected-filter-chip',
	templateUrl: './selected-filter-chip.component.html',
	styleUrls: ['./selected-filter-chip.component.scss'],
	imports: [NHATestDirective, MatButtonModule, MatMenuModule, MatIconModule, MatTooltip]
})
export class NHASelectedFilterChipComponent extends FilterBaseComponent {
	@Output() deselect: EventEmitter<{ filterKey: string; item: IFilterItem }> = new EventEmitter();
	@Output() deselectAll: EventEmitter<string> = new EventEmitter();

	selectedItems = computed(() => this.filter().items.filter((f) => f.selected && !!f.label));
	filterTitle = computed(() => this.filter().title.replace(/percentile/gi, ''));

	constructor() {
		super();
	}

	onDeselectItem(item: IFilterItem): void {
		this.select(this.filterKey(), this.filter(), item.id);
	}

	onDeselectAll(): void {
		this.deselectAll.emit(this.filterKey());
	}
}
